"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableGroup = void 0;

var React = _interopRequireWildcard(require("react"));

var _dateFns = require("date-fns");

var _blocks = require("@bueno/blocks");

var _utils = require("../utils");

var _storage = require("../../../utils/storage");

var _GroupGrid = _interopRequireDefault(require("./components/GroupGrid"));

var _ProgressiveList = _interopRequireDefault(require("../../ProgressiveList"));

var _analysis = require("../../../context/analysis");

var _constants = require("../utils/constants");

function getInitialAmount(groupCount) {
  const DEFAULT_RENDER_LIMIT = 20;
  return groupCount > DEFAULT_RENDER_LIMIT ? DEFAULT_RENDER_LIMIT : groupCount;
}

function renderGroup(composed, group, showSnoozed, expandAll, groupAssets, filtered, viewMode) {
  return index => {
    const groupedOccurrences = composed[index];
    if (!groupedOccurrences) return null;
    const instance = groupedOccurrences[0];
    const postGroupedOccurrences = showSnoozed ? groupedOccurrences : groupedOccurrences.filter(ins => !ins.isAllSnoozed);
    const insightsCount = postGroupedOccurrences.length;
    const insightsCountToday = groupedOccurrences.reduce((count, ins) => count + (ins.latest === (0, _dateFns.format)(new Date(), 'yyyy-MM-dd') ? 1 : 0), 0);
    const equipsCount = (0, _utils.getEquipsCount)(groupedOccurrences, showSnoozed);
    const unassociatedEquipsCount = (0, _utils.getUnassociatedEquipsCount)(groupedOccurrences, showSnoozed);
    const key = (0, _utils.getGroupId)(group, instance);
    const expanded = (0, _storage.getPersisted)({
      key: _constants.EXPANDING_KEY[viewMode],
      prop: key
    }, false);
    const {
      Heading
    } = groupAssets;
    return /*#__PURE__*/React.createElement(_blocks.ExpandableItem, {
      key: `${key}-${expandAll}-${index}`,
      expanded: expandAll || expanded,
      onClick: visible => (0, _storage.setPersisted)({
        key: _constants.EXPANDING_KEY[viewMode],
        prop: key
      }, Boolean(visible)),
      renderHeader: /*#__PURE__*/React.createElement(Heading, {
        instance: instance,
        insightsCount: insightsCount,
        insightsCountToday: insightsCountToday,
        equipsCount: equipsCount,
        unassociatedEquipsCount: unassociatedEquipsCount
      })
    }, /*#__PURE__*/React.createElement(_GroupGrid.default, {
      persistKey: key,
      groupAssets: groupAssets,
      occurrences: postGroupedOccurrences,
      filtered: filtered,
      showSnoozed: showSnoozed
    }));
  };
}

const ExpandableGroup = /*#__PURE__*/React.memo(({
  showSnoozed,
  finalGrouped,
  expandAll,
  filtered
}) => {
  const {
    viewMode
  } = (0, _analysis.useState)();
  const [rowCount, setRowCount] = React.useState(finalGrouped.composed.length);
  const getAssets = React.useCallback(() => (0, _utils.getGroupAssets)(finalGrouped.group), [finalGrouped.group]);
  React.useLayoutEffect(() => {
    if (filtered.length === 0) {
      setRowCount(finalGrouped.composed.length);
    } else {
      setRowCount(filtered.length);
    }
  }, [filtered.length, finalGrouped.composed.length]);
  return /*#__PURE__*/React.createElement(_blocks.ExpandableList, null, finalGrouped.composed.length > 0 && /*#__PURE__*/React.createElement(_ProgressiveList.default, {
    initialAmount: getInitialAmount(finalGrouped.composed.length),
    useWindowScroll: true,
    progressiveAmount: 5,
    renderItem: renderGroup(finalGrouped.composed, finalGrouped.group, showSnoozed, expandAll, getAssets(), filtered, viewMode),
    rowCount: rowCount
  }));
});
exports.ExpandableGroup = ExpandableGroup;